import { SitePageList } from '../framework/pages/site-pages'

export const SitePagesWrapper = () => {
  return (
    <>
      <SitePageList />
    </>)
}